
import { useState, useEffect, useCallback } from 'react';
import {
  FormattedReview,
  AllReviewsData,
  PlaceReviewsData,
  ConsultorioId
} from '../../types';
import { apiRequest, API_CONFIG, PLACE_IDS } from '../../config/googleReviewsApi';

export interface UseGoogleReviewsReturn {
  reviews: FormattedReview[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useGoogleReviews = (
  consultorioId?: ConsultorioId | 'all',
  limit?: number
): UseGoogleReviewsReturn => {
  const [reviews, setReviews] = useState<FormattedReview[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchReviews = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      let endpoint: string;
      
      if (!consultorioId || consultorioId === 'all') {
        endpoint = limit ? `${API_CONFIG.endpoints.recent}?limit=${limit}` : API_CONFIG.endpoints.allReviews;
      } else {
        const placeId = PLACE_IDS[consultorioId];
        endpoint = `${API_CONFIG.endpoints.placeReviews}/${placeId}`;
      }

      if (!consultorioId || consultorioId === 'all') {
        const data = await apiRequest<AllReviewsData>(endpoint);
        const reviewsToSet = limit ? data.reviews.slice(0, limit) : data.reviews;
        setReviews(reviewsToSet);
      } else {
        const data = await apiRequest<PlaceReviewsData>(endpoint);
        const reviewsToSet = limit ? data.reviews.slice(0, limit) : data.reviews;
        setReviews(reviewsToSet);
      }

    } catch (err) {
      console.error('❌ Erro ao buscar avaliações do Google:', err);
      const errorMessage = err instanceof Error ? err.message : 'Erro desconhecido';
      setError(errorMessage);
      setReviews([]);
    } finally {
      setLoading(false);
    }
  }, [consultorioId, limit]);

  const refetch = useCallback(async () => {
    await fetchReviews();
  }, [fetchReviews]);

  useEffect(() => {
    fetchReviews();
  }, [fetchReviews]);

  return {
    reviews,
    loading,
    error,
    refetch
  };
};
